export const SET_STATUS_BAR = 'Dyzio/StatusBar/SET_STATUS_BAR';
export const CLEAR_STATUS_BAR = 'Dyzio/StatusBar/CLEAR_STATUS_BAR';



/** WEBPACK FOOTER **
 ** ./src/containers/status-bar/constants.js
 **/